<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col md="6">
        <FormDevice @submit="submit" :title="'Add Device'" :form="{region: null, branch: null, device: null}"></FormDevice>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import axios from 'axios'
import FormDevice from '@/views/admin/device/FormDevice'

export default {
  name: 'adddevice',
  components: {
    FormDevice
  },
  methods: {
    submit (form) {
      let scope = this; 

      form.user = scope.$store.getters.currentUser.id

      axios.post(process.env.VUE_APP_API + '/device', form, {
      headers: {
        Authorization: 'JWT ' + scope.$localStorage.get('holly-fi-token')
        }
      })
        .then(function (response) {
          scope.$router.push('/admin/devices/list')
        })
        .catch(function (error) {
          console.log(error);
        });
    }
  }
}
</script>

<style scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>
